import { sendGet, sendPost, sendDelete, sendPut, sendPutWithoutSignOut, sendPatch } from "../baseUtils";

export const getSquareLocations = id =>
  sendGet(`/integrated_stores/${id}/square_locations`).then(res => {
    return res.data;
  });

export const getSettings = () =>
  sendGet("/data/account").then(res => {
    return res.data;
  });

export const getPricingRules = () => sendGet("/stores/pricing_rule").then(res => res.data);

export const updatePricingRules = params => sendPatch("/stores/pricing_rule", params);

export const setDisableBrandedInvoicing = async disabled_invoicing =>
  sendPut("/stores/personalization", disabled_invoicing);

export const getAddress = () => sendGet("/stores/address").then(res => res.data);

export const updateStore = async params => sendPut("/store", params);

export const updateAddress = async params => {
  const { address, zipcode, city, country, state, isUpdate } = params;

  const data = {
    line_one: address,
    line_two: "",
    city,
    state,
    country,
    zip: zipcode
  };

  if (isUpdate) return sendPut("/stores/address", data);

  return sendPost("/stores/address", data);
};

export const updateLogo = async params => sendPost("/stores/logo", params);

export const deleteLogo = async () => sendDelete("/stores/logo");

export const setPauseStore = async () => sendPutWithoutSignOut("/store/pause");

export const setUnpauseStore = async () => sendPutWithoutSignOut("/store/unpause");

export const getDropshippersData = () =>
  sendGet("/data").then(res => {
    return res.data;
  });
